export const labels = {
  companyName: 'Įmonės pavadinimas',
  companyRegNo: 'Registracijos nr.:',
  companyVatNo: 'PVM kodas:',
  provider: 'Tiekėjas',
  customer: 'Klientas',
  invoice: 'Sąskaita',
  invoiceDate: 'Sąskaitos išrašymo data',
  invoiceNumber: 'Sąskaitos numeris',
  invoiceSeries: 'Sąskaitos serija',
  worksCompleted: 'Atlikti darbai / suteiktos paslaugos',
  date: 'Data',
  description: 'Aprašymas',
  qty: 'Kiekis',
  unit: 'Matas',
  rate: 'Įkainis',
  total: 'Viso',
  vatBasis: 'PVM taikomas sumai',
  vatAmount: 'PVM suma',
  vatRate: 'PVM tarifas',
  vatRatePct: 'PVM tarifas %',
  currency: 'Valiuta',
  vat: 'PVM',
  totalPayable: 'Viso mokėti',
  addNew: 'Pridėti naują eilutę',
  invoiceMeta: 'Sąskaitos informacija',
  invoiceBranding: 'Sąskaitos firminis stilius',
  companyId: 'Įmonės identifikacija',
  enterEntryDescription: 'Eilutės aprašymas',
  billingInformation: 'Atsiskaitymo informacija',
  billingBankAccountIban: 'IBAN:',
  billingBankAccountBic: 'BIC:',
  billingBankAccountNo: 'Sąskaitos nr:',
  billingBankAccountSortCode: 'Bankas:',
  name: 'Vardas',
  brandName: 'Pavadinimo pirma dalis',
  brandSubName: 'Pavadinimo antra dalis',
  role: 'Pareigos',
  addressLine1: 'Adreso eilutė 1',
  addressLine2: 'Adreso eilutė 2',
  addressLine3: 'Adreso eilutė 3',
  addressLine4: 'Adreso eilutė 4',

  // other interface translations
  dateFormat: 'YYYY-MM-DD',
  // show: 'Show',
  // hide: 'Hide',
  showForm: 'Rodyti formą',
  hideForm: 'Nerodyti formos',
  note: 'Pastaba',
  createNewInvoice: 'Kurti naują sąskaitą',
  creatingNewInvoice: 'Kuriama nauja sąskaita faktūra',
  editingExistingInvoice: 'Redaguojama faktūra',
  saveInvoice: 'Įšsaugoti sąskaitą',
  lock: 'Užrakinti',
  unlock: 'Atrakinti',
  deleteInvoice: 'Ištrinti sąskaitą',
  companyDetails: 'Įmonės duomenys',
  representativeDetails: 'Įmonę atstovaujantis asmuo',
  companyAddress: 'Įmonės adresas',
  billingInfo: 'Atsiskaitymo info',
  isClientVatRegistered: 'Ar klientas yra PVM mokėtojas?',
  prefillCustomer: 'Pildyti',
  selectExistingCustomer: 'Parinkti iš esamų klientų',
  showingCustomersWithDetails: 'Rodomi klientai, kurių "Adreso eilutė 1" įvesta.',
}